import React from 'react';
import WidgetMachinesSection from 'components/quote_builder_widget/sections/WidgetMachinesSection';

const DIE_CUTTING_MACHINE_LABELS = {
  information: 'die_cutting_machines_information',
  add: 'add_die_cutting_machine',
  select: 'select_die_cutting_machine',
  noneAdded: 'no_die_cutting_machines_enabled',
  noWidgetMaterials: 'no_widget_materials_for_die_cutting',
  noMachines: 'no_die_cutting_machines',
  noMachinesForMaterials: 'no_die_cutting_machines_for_materials',
  noAllowedTypes: 'no_widget_materials_for_die_cutting',
  notUsed: 'die_cutting_machine_not_used',
  failedToLoad: 'failed_to_load_die_cutting_machines',
  failedToUpdate: 'failed_to_update_die_cutting_machine',
  createNew: 'create_new_die_cutting_machine',
};

const DieCuttingMachinesSection = ({ onDieCuttingMachinesChange }) => (
  <WidgetMachinesSection
    machineKey="die_cutting_machine"
    listUrl="/quote-builder/widgets/die-cutting-machines"
    listField="die_cutting_machines"
    allowedTypesField="widget_material_groups"
    warningsField="warnings"
    labels={DIE_CUTTING_MACHINE_LABELS}
    machineLabel="quote_builder.die_cutting_machine"
    onMachinesChange={onDieCuttingMachinesChange}
  />
);

export default DieCuttingMachinesSection;
